import { useEffect, useState } from 'react';

const STORAGE_KEY = 'adhc.currentWorkspaceId';

const listeners = new Set<() => void>();

function readStored(): string | null {
  try {
    return typeof localStorage !== 'undefined'
      ? localStorage.getItem(STORAGE_KEY)
      : null;
  } catch {
    return null;
  }
}

function writeStored(id: string | null) {
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
  for (const fn of listeners) fn();
}

export function useWorkspaceId(): string | null {
  const [id, setId] = useState<string | null>(readStored);
  useEffect(() => {
    const update = () => setId(readStored());
    listeners.add(update);
    return () => { listeners.delete(update); };
  }, []);
  return id;
}

export function setWorkspaceId(id: string | null): void {
  writeStored(id);
}
